import React, { useCallback, useState } from 'react';
import Context, { UserInfo } from './Context';

const defaultValue: UserInfo = {
  rxTied: false,
  hasRxCId: true,
  dontCollectProfile: false,
  userType: '',
  lookupId: '',
  lookupToken: '',
  entryPoint: '',
  caregiveeInfo: {
    firstName: '',
    lastName: '',
    notificationType: '',
    notificationValue: '',
    sourceSystems: []
  },
  caregiverInfo: {
    firstName: '',
    lastName: '',
    notificationType: '',
    notificationValue: '',
    sourceSystems: []
  },
  updated: false
};

const Provider = ({ children }) => {
  const [user, setUserValues] = useState<UserInfo>(defaultValue);

  const updateUser = useCallback(
    (value: UserInfo) => setUserValues((oldUser) => ({ ...oldUser, ...value })),
    [setUserValues]
  );

  const UserContext = {
    user,
    updateUser
  };
  return <Context.Provider value={UserContext}>{children}</Context.Provider>;
};

export default Provider;
